import * as React from 'react';

export const ApplicationCopy = {
    applicationName: 'BODY KNOWLEDGE',
};

export const TOTAL_BODY_WATER_PANEL_TITLE: string = 'Total Body Water';
export const TOTAL_BODY_WATER_POPOVER_TITLE: string = 'Total Body Water:';
export const TOTAL_BODY_WATER_INFO: JSX.Element = (
    <div>
        <p>Total poundage of water in your body.</p>
        <p>
            Water is often forgot about in the conversation about muscle as protein tends to steal the spotlight. Water is actually more abundant than protein
            in your body and is constantly necessary for everyday processes your body performs.
        </p>
        <p>
            Bottom line, drink AT LEAST 80 OZ's of water per day. It's free and can result in significant shifts in body composition if you aren't already
            drinking enough.
        </p>
    </div>
);

export const SEGMENTAL_ANALYSIS_PANEL_TITLE: string = 'Segmental Lean Analysis';
export const SEGMENTAL_ANALYSIS_POPOVER_TITLE: string = 'Segmental Lean Analysis:';
export const SEGMENTAL_ANALYSIS_INFO: JSX.Element = (
    <div>
        <p>Fat-free mass per segment of your body.</p>
        <p>
            This will show if the way you're carrying Fat Free Mass is balanced or not. Ideally, we would want our limbs to be even and our bodies to be
            balanced in the way we carry FFM.
        </p>
        <p>
            If you have over 1/2 LB difference between limbs, this is a significant imbalance and this should be addressed if you're not already aware of the
            reason (injury, swelling, lymphedema, etc) for this.
        </p>
    </div>
);

export const SKELETAL_MUSCLE_MASS_PANEL_TITLE: string = 'Skeletal Muscle Mass';
export const SKELETAL_MUSCLE_MASS_POPOVER_TITLE: string = 'Skeletal Muscle Mass:';
export const SKELETAL_MUSCLE_MASS_INFO: JSX.Element = (
    <div>
        <p>
            Skeletal muscle mass (SMM) is considered the muscles that we can control with exercise. Our hamstrings, biceps, quadriceps, glutes and triceps are a
            few great examples of SMM.
        </p>
        <p>
            Skeletal muscle can be changed and influenced through diet and exercise whereas our heart (cardiac muscle) or lungs (smooth muscle) don't change
            much in size from exercise but rather become more efficient. Gain all the SMM you can, where you can and while you can because it gets harder to
            gain as we age.
        </p>
    </div>
);

export const VISCERAL_FAT_PANEL_TITLE: string = 'Visceral Fat Level';
export const VISCERAL_FAT_POPOVER_TITLE: string = 'Visceral Fat Level:';
export const VISCERAL_FAT_INFO: JSX.Element = (
    <div>
        <p>
            Visceral fat level indicates how much fat we have surrounding our organs. Visceral fat is not skin deep so we can't see or pinch it. It is
            underneath the abdominal wall and is the deeper, more dangerous kind of fat.
        </p>
        <p>
            Visceral fat level ranges from 1-20. 1 is low and 20 is high. We like to see the number close to 10 or below. The lower the better with visceral fat
            but be warned, you will never have none! It is essential to our experience but we don't want an excess.
        </p>
    </div>
);

export const BODY_FAT_PANEL_TITLE: string = 'Body Fat';
export const BODY_FAT_POPOVER_TITLE: string = 'Body Fat:';
export const BODY_FAT_INFO: JSX.Element = (
    <div>
        <p>Total pounds of fat on your body. </p>
        <p>
            This is a great number to use to set goals! Our body fat in pounds tends to see more gain/loss than our % so we highly recommend using this number
            to set your goal.
        </p>
        <p>Fat Mass/Total Weight</p>
        <p>
            Our % body fat is a key indicator of health. Ideally, males would be between 10-20% and females between 18-28% but this is NOT average but IDEAL.
            Shifts in % body fat can occur from the loss or gain of Lean Mass as well so make sure to keep that muscle on!
        </p>
    </div>
);

export const METABOLIC_RATE_PANEL_TITLE: string = 'Basal Metabolic Rate';
export const METABOLIC_RATE_POPOVER_TITLE: string = 'Basal Metabolic Rate:';
export const METABOLIC_RATE_INFO: JSX.Element = (
    <div>
        <p>The total amount of calories you burn in 24 hours with absolutely NO MOVEMENT. Consider these "coma calories".</p>
        <p>
            The body is constantly using energy to operate our heart, brain, lungs and other essential processes. Eating below your BMR, on purpose and over
            time, will result in muscle loss and NO ONE wants to lose muscle. Never eat below your BMR on purpose unless it is medically advised.
        </p>
    </div>
);

export const DASHBOARD_NEED_HELP_BUTTON_TEXT: string = 'Need Help?';

export const HELP_MODAL_TITLE: string = 'I would like help with...';
export const HELP_MODAL_INFO_TEXT: string = 'An email will be sent to the gym where you did your last scan; The gym staff will follow up with you directly.';
export const HELP_MODAL_CONFIRMATION: string = 'Your request has been sent.';
export const HELP_MODAL_CLOSE_BUTTON_TEXT: string = 'Close';
export const HELP_MODAL_CONFIRM_BUTTON_TEXT: string = 'Send';
export const HELP_MODAL_SERVER_ERROR_MESSAGE: string = 'there was an error processing your request.';

export const BALANCED: string = 'BALANCED';
export const RL_IMBALANCE: string = 'R/L Imbalance';
export const TOP_HEAVY: string = 'Top Heavy';
export const BOTTOM_HEAVY: string = 'Bottom Heavy';



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/assets/ApplicationCopy.tsx